import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Form, List, Card, Button, Radio, Checkbox, Switch } from 'antd';
import _ from 'lodash'
import $ from 'jquery'
import qs from 'query-string';
import { SearchOutlined, CopyOutlined, FormOutlined, ShopOutlined } from '@ant-design/icons';
import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import {API_HOST}  from '../../configs/env';
import whttp    from '../../libs/whttp';
import { genFormItemAtrribute } from 'libs/FormHelper'
import { RadioControl, CheckboxControl } from '@wordpress/components'
import { withState } from '@wordpress/compose';
import bannerImage from 'assets/img/banner/banner-catalog.png';
import CatalogueInfoPos from './catalogue-info-pos'
const INDEX_URL = _.get(window,'VC_CONFIG.INDEX_URL')

const defaultListInfo = {
  "current": 1, //目前頁數
  "page_size": 10, //一頁幾筆
  "total": 1, //以此query條件，總共幾筆資料
  "rows": []
}
const CataloguMode = {
  Default: 1, // 預設列表
  Slider : 2, // 首頁橫向滑動
}

// 前端頁面
export default class CataloguePos extends Component {
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }

  componentDidMount(){
    AppHelper.updateConfig()
    this.loadData()
  }
  loadData = (opt = { page: 1, page_size: 'all' }) => {
    
    const tableQuery = _.get(this,'state.tableQuery',{});
    const { page, page_size } = opt;
    this.setState({ isLoadingData: true })
    
    whttp.get(API_HOST + '/api/v1/catalogues', {
      page: page,
      page_size: page_size,
    }, (state, res) => {
      this.setState({ isLoadingData: false })
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) { return this.setState({ message: '發生錯誤' }); }

      if (code !== 200) { return this.setState({ message: reason }); }

      this.setState({ listInfo: data },()=> {
        this.reloadSwiper()
      })
      
    });
  }
  reloadSwiper = () => {
    const Swiper = window.Swiper

    if (!Swiper) return

    window.swiperCatalog = new Swiper('.catalog-swiper', {
      slidesPerView: 5,
      spaceBetween: 30,

      loop: true,
      navigation: {
        nextEl: '.catalog-swiper-button-next',
        prevEl: '.catalog-swiper-button-prev',
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        767: {
          slidesPerView: 3,
          spaceBetween: 0,
          centeredSlides: true,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
        }
      }
    });
    
  }
  genInfoLink = (id) => {
    const location = window.location
    return`${location.protocol}//${location.host}${location.pathname}?view=kiosk&id=${id}`
  }
  render() {
    const {listInfo={} } = this.state;
    const catalogues = _.get(this,'state.listInfo.rows',[])
    const options = _.get(this, 'props.app.options', {})
    const category_ids = _.get(this.props, 'category_ids', [])
    const catalogue_categories = _.get(options, 'catalogue_categories', []).sort((a,b)=>a.id-b.id)
    const selectedCategoryId = _.get(this, 'state.selectedCategoryId', _.get(catalogue_categories,'0.id'))
    const mode = _.get(this, 'props.mode', CataloguMode.Default)
    const urlQuery = AppHelper.getURLQuery()
    const isKiosk = urlQuery.view
    const Local = _.get(window, 'VC_CONFIG.Locale')
    const NavTavCate = []
    catalogue_categories.forEach(category => {
      catalogues.find(item =>(item.category_id === category.id)) && NavTavCate.push(category)
    })

    const catalogueID = _.get(urlQuery, 'id')

    if (!_.isEmpty(catalogueID)) {
      return (
        <CatalogueInfoPos />
      )
    }
    
    return (
      <main className="bg-light">
        <div className="tab-content" id="pills-tabContent">
          {_.map(NavTavCate, (category,idx) => {              
            return (
                <div className="container" key={idx}>
                  <section className="py-lg-5">
                    <h2 className="card-title">{category.name}</h2>
                    <div className="row">
                      {catalogues.filter(catalogues => catalogues.category_id === category.id)
                        .map((catalogue, idx) => {
                          //const imageurl =  reactStringReplace(_.first(catalogue.images), 'mpp', 'www') 
                          //console.log('imageurl',imageurl)
                          return (
                            <div key={idx} className="col-6 col-md-4 column-lg-5 mb-4 wow fadeInUp" data-wow-delay="0.1s">
                              <a className="catalog-item mb-3" role="button" href={this.genInfoLink(catalogue.id)}>
                                <span className="cover img-catalog mb-2" style={{ backgroundImage:`url(${_.first(catalogue.images).replace('mppuni-prosperity', 'wwwuni-prosperity')})`}}><span className="more"><i className="fas fa-eye"></i></span></span>
                                <h6 className="note align-self-start text-navy fw-700 mb-1">{Local == "zh_TW" &&catalogue.name}{Local == "en_US" &&catalogue.en_name}</h6>
                                <div className="d-flex flex-lg-row flex-column justify-content-between aling-items-center w-100">
                                  <p className="note mb-lg-0 mb-2 text-dark">{catalogue.promotion_start_date}-{catalogue.promotion_end_date}</p>
                                </div>
                              </a>
                            </div>
                          )
                        })
                      }
                    </div>
                  </section>
                </div>
            )
          })}
        </div>
      </main>
    )
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4, }
export class CataloguePosEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount(){
    AppHelper.updateConfig()
    this.formRef.current.setFieldsValue(this.props.attributes)
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    
    return (
      <div className="vu-blocks-editor">
        <div className="components-placeholder__label">
          <span className="block-editor-block-icon">
            <div alt="f538" className="dashicons dashicons-layout" />
          </span>
          促銷目錄列表
        </div>
        <Form
          ref={this.formRef}
          name="basic"
          className='basicForm'
          // layout="vertical"
          // onFinish={values => this.submitData(values)}
          onValuesChange={(changedFields, allFields) => this.props.setAttributes(changedFields)}
        >
          <Form.Item
            {...genFormItemAtrribute('category_ids', '目錄類別')}
          >
            <Checkbox.Group>
              <List
                grid={listGrid}
                dataSource={_.get(options, 'catalogue_categories', [])}
                renderItem={item => (
                  <List.Item>
                    <Checkbox value={item.id}>{item.name}</Checkbox>
                  </List.Item>
                )}
              />
            </Checkbox.Group>
          </Form.Item>
        </Form>
      </div>
      
    )
  }
}  


// WEBPACK FOOTER //
// ./src/blocks/catalogues/catalogue-pos.js